import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Tooltip,
  Typography,
} from "@mui/material";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import { stripSecondsFromTime, monthList, pad } from "../../utils/jsUtils";
import { CopyAll } from "@mui/icons-material";
import { useNotificationContext } from "../../common/NotificationContext";
const ConfirmationDialog = ({ open, handleClose, appointmentData }) => {
  const { showNotification } = useNotificationContext();
  function convertDate(inputFormat) {
    if (inputFormat && inputFormat !== "") {
      let date = new Date(inputFormat);
      return [
        pad(date.getDate()),
        monthList[date.getMonth()],
        date.getFullYear(),
      ].join("-");
    }
    return "-";
  }
  return (
    <>
      <Dialog
        open={open}
        maxWidth={"lg"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Grid container display={"flex"} justifyContent="center">
          <Grid
            item
            xs={12}
            display={"flex"}
            justifyContent="center"
            alignSelf={"center"}
            pt={3}
            px={6}
          >
            <EventAvailableIcon color="primary" sx={{ fontSize: "75px" }} />
          </Grid>
          <Grid item alignSelf={"center"} pt={2} px={6}>
            <Typography variant="h6" textAlign={"center"} mb={1}>
              {" "}
              {"Your Appointment Request Successfully Sent"}
            </Typography>
            <Typography gutterBottom>
              {"We have sent your booking information to your email address"}
            </Typography>
          </Grid>
        </Grid>
        <DialogContent dividers={true} sx={{ px: 6, py: 5 }}>
          <Grid container sx={{ backgroundColor: "#4d6fa53b" }}>
            <Grid item xs={12} md={12} textAlign={"left"}>
              <Box sx={{ mt: 2, mb: 3, px: 3 }}>
                <Typography fontSize={13}>Appointment Id</Typography>
                <Box display={"flex"}>
                  <Typography
                    variant="h6"
                    color={"primary"}
                    style={{ whiteSpace: "pre-line", fontWeight: 500 }}
                  >
                    {" "}
                    {appointmentData?.appointmentId}{" "}
                  </Typography>
                  <Tooltip title="Copy">
                    <CopyAll
                      color="primary"
                      onClick={() => {
                        navigator.clipboard.writeText(
                          appointmentData?.appointmentId
                        );
                        showNotification(
                          "Copied",
                          "Copied successfully",
                          "info"
                        );
                      }}
                      sx={{ cursor: "pointer", ml: 0.5 }}
                    />
                  </Tooltip>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={6} textAlign={"left"}>
              <Box sx={{ mt: 1, mb: 3, px: 3 }}>
                <Typography fontSize={13}>Appointment Date</Typography>
                <Typography
                  variant="h6"
                  color={"primary"}
                  style={{ whiteSpace: "pre-line", fontWeight: 500 }}
                >
                  {" "}
                  {convertDate(appointmentData?.appointmentDate)}{" "}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6} textAlign={"left"}>
              <Box sx={{ mt: 1, mb: 3, px: 3 }}>
                <Typography fontSize={13}>Appointment Time</Typography>
                <Typography
                  variant="h6"
                  color={"primary"}
                  style={{ whiteSpace: "pre-line" }}
                >
                  {" "}
                  {stripSecondsFromTime(appointmentData?.startTime)}
                  {!!appointmentData?.endTime &&
                    `- ${appointmentData?.endTime}`}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={() => {
              handleClose();
            }}
            autoFocus
            color="primary"
            variant="outlined"
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default ConfirmationDialog;
